import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Fabricante } from 'src/app/admihair/api/dto/fabricante';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FabricanteService } from 'src/app/admihair/service/fabricante.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-fabricante-editar',
  templateUrl: './fabricante-editar.component.html',
  styleUrls: ['./fabricante-editar.component.scss']
})
export class FabricanteEditarComponent extends AdmihairBaseComponent implements OnInit {
  
  loading: boolean = false;
  id?: number;
  fabricante?: Fabricante;
  progressoRequisicao: boolean = false;
  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute,
    private fabricanteService: FabricanteService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }


  ngOnInit(): void {
    this.loading = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_FABRICANTE');
    this.carregarIdFabricante();
    if (this.permissaoEditar) {
      this.carregarFabricantePorId();
    }
  }

  atualizar() {
    if (this.id && this.fabricante) {
      this.progressoRequisicao = true
      this.fabricanteService.atualizar(this.id, this.fabricante).subscribe({
        next: (data: Fabricante) => {
          this.progressoRequisicao = false;
          this.fabricante = data;
          this.exibirMensagemSucesso()
        },
        error: (error: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(error);
        }
      });

    }
  }

  carregarFabricantePorId() {
    this.fabricanteService.buscarFabricantePorId(this.id).subscribe({
      next: (data: Fabricante) => {
        this.fabricante = data;
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        this.exibirMensagemErro(error);
      }
    });
  }

  carregarIdFabricante() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }


  limparFormulario() {
    this.form?.reset();
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }


}
